import { persist } from "zustand/middleware";

import { InitialUserPageType } from "../types/global";

const initailStore: InitialUserPageType = {
  currentPage: "",
  clearCurrentPageState: () => {},
  setCurrentPageState: () => {},
};

const currentPageStore = persist(
  (set: any) => ({
    currentPage: initailStore.currentPage,
    setCurrentPageState: (data: string) => set(() => ({ currentPage: data })),
    clearCurrentPageState: () => set({ currentPage: initailStore.currentPage }),
  }),
  {
    name: "user-current-page",
    version: 0.1,
  },
);

export { currentPageStore };
